import { HttpErrorResponse } from '@angular/common/http';
import { signal } from '@angular/core';

export class ApiCallState {
  readonly request = signal<unknown | undefined>(undefined);
  readonly response = signal<unknown | undefined>(undefined);
  readonly error = signal<unknown | undefined>(undefined);

  start(request?: unknown): void {
    this.request.set(request);
    this.response.set(undefined);
    this.error.set(undefined);
  }

  succeed(response: unknown): void {
    this.response.set(response);
    this.error.set(undefined);
  }

  fail(error: unknown): void {
    this.error.set(normalizeError(error));
    this.response.set(undefined);
  }

  clear(): void {
    this.request.set(undefined);
    this.response.set(undefined);
    this.error.set(undefined);
  }
}

function normalizeError(error: unknown): unknown {
  if (error instanceof HttpErrorResponse) {
    return {
      status: error.status,
      statusText: error.statusText,
      message: error.message,
      url: error.url,
      error: error.error,
    };
  }

  if (error instanceof Error) {
    return { name: error.name, message: error.message };
  }

  return error;
}